// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import isTouchDevice from "@insite/client-framework/Common/Utilities/isTouchDevice";
import { CategoryContext } from "@insite/client-framework/Components/CategoryContext";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
// import { ProductContext } from "@insite/client-framework/Components/ProductContext"; // Starter Custom Code
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadCarouselProducts from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import {
    getErrorMessage,
    getProductsForProductInfoList,
} from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import sendImpressionTracking from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/SendImpressionTracking";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
/* Starter Custom Code
import ProductCarouselProduct, {
    ProductCarouselProductStyles,
} from "@insite/content-library/Components/ProductCarouselProduct";
*/
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { createRef, useContext, useEffect, useMemo, useState } from "react";
import { connect, ResolveThunks, shallowEqual } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

/* Starter Custom Code - Start */
import {
    HasProductContext,
    ProductContext,
    withProductContext,
} from "@insite/client-framework/Components/ProductContext";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import getTextAlignmentField, { textAlignmentOptions } from "@store/Framework/Common/Fields/Toolkit/textAlignment";
import { BlockProps } from "@store/Library/Components/Toolkit/Block";
import blockFullWidthField from "@store/Library/Components/Toolkit/Block/fields/fullWidth";
import blockMarginField from "@store/Library/Components/Toolkit/Block/fields/margin";
import blockVariantField from "@store/Library/Components/Toolkit/Block/fields/variant";
import blockVariantSideField from "@store/Library/Components/Toolkit/Block/fields/variantSide";

import { carouselProps } from "@store/Themes/common/props/carousel";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import getMatchingDataFromDictionary from "@toolkit/Framework/Common/Utilities/getMatchingDataFromDictionary";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";

export type ProductCarouselVariant = typeof ProductCarouselVariant[keyof typeof ProductCarouselVariant];
export const ProductCarouselVariant = {
    None: "none",
    ProductDetails: "productDetails",
} as const;

/* Store Custom Code - Start */
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import usePrevious from "@insite/client-framework/Common/Hooks/usePrevious";
import { ProductRecommendationWidgetModel } from "@insite/client-framework/Services/ProductRecommendationsService";
import { productCardProps } from "@store/Themes/common/props/productCard";
import { fields as imageOverFields, imageHoverOptions } from "@store/Framework/Common/Hooks/useSecondImageOnHover";
import ProductCarouselProduct, {
    ProductCarouselProductStyles,
} from "@store/Overrides/Components/ProductCarouselProduct";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import useEmblaCarousel from "embla-carousel-react";
/* Store Custom Code - End */

const AnchorHeading = getWidgetComponent("ProductDetails/ProductDetailsAnchorHeading");
/* Starter Custom Code - End */

enum localFields {
    title = "title",
    hideVariantParents = "hideVariantParents",
    carouselType = "carouselType",
    displayProductsFrom = "displayProductsFrom",
    selectedCategoryIds = "selectedCategoryIds",
    relatedProductType = "relatedProductType",
    numberOfProductsToDisplay = "numberOfProductsToDisplay",
    seedWithManuallyAssigned = "seedWithManuallyAssigned",
    maxNumberOfColumns = "maxNumberOfColumns",
    widgetPosition = "widgetPosition",
    showImage = "showImage",
    showTitle = "showTitle",
    showBrandName = "showBrandName",
    showPartNumbers = "showPartNumbers",
    showPrice = "showPrice",
    showAddToCart = "showAddToCart",
    showAddToList = "showAddToList",
    showImageBadges = "showImageBadges",
    maximumNumberOfImageBadges = "maximumNumberOfImageBadges",
    showTextBadges = "showTextBadges",
    maximumNumberOfTextBadges = "maximumNumberOfTextBadges",
    // Starter Custom Code
    showAvailability = "showAvailability",
    showAttributes = "showAttributes",
    showDots = "showDots",
    titleAlignment = "titleAlignment",
    variant = "variant",
    blockFullWidth = "blockFullWidth",
    blockVariant = "blockVariant",
    blockVariantSide = "blockVariantSide",
    blockMargin = "blockMargin",
    // Store Custom Code
    selectedCategory = "selectedCategory",
}

const fields = { ...localFields, ...imageOverFields };
interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.carouselType]: string;
        [fields.displayProductsFrom]: string;
        [fields.selectedCategoryIds]: string[];
        [fields.relatedProductType]: string;
        [fields.numberOfProductsToDisplay]: number;
        [fields.seedWithManuallyAssigned]: string;
        [fields.maxNumberOfColumns]: number;
        [fields.widgetPosition]: number;
        [fields.showImage]: boolean;
        [fields.showTitle]: boolean;
        [fields.showBrandName]: boolean;
        [fields.showPartNumbers]: boolean;
        [fields.showPrice]: boolean;
        [fields.showAddToCart]: boolean;
        [fields.showAddToList]: boolean;
        [fields.showImageBadges]: boolean;
        [fields.maximumNumberOfImageBadges]: number;
        [fields.showTextBadges]: boolean;
        [fields.maximumNumberOfTextBadges]: number;
        // Starter Custom Code
        [fields.showAvailability]: boolean;
        [fields.showAttributes]: boolean;
        [fields.showDots]: boolean;
        [fields.titleAlignment]: string;
        [fields.variant]: ProductCarouselVariant;
        [fields.blockFullWidth]: boolean;
        [fields.blockVariant]: string;
        [fields.blockVariantSide]: string;
        [fields.blockMargin]: string;
        // Store Custom Code
        [fields.selectedCategory]: string[];
        [fields.hideVariantParents]: boolean;
        [fields.transitionTimingFunction]: string;
        [fields.transitionDuration]: number;
        [fields.enableImageHover]: boolean;
    };
}

/* Starter Custom Code - Start */
const titleAlignmentField = getTextAlignmentField(fields.titleAlignment);
/* Starter Custom Code - End */

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps & HasProductContext /* Starter Custom Code */) => {
    const carouselId = `${ownProps.id}-${ownProps.productContext?.product?.id}`; // Starter Custom Code
    return {
        /* Store Deleted code moved into function body */
        errorMessage: getErrorMessage(state, carouselId), // Starter Custom Code
        pageType: getCurrentPage(state).type,
        productRecommendationWidgets: state.components.productRecommendations.widgets,
        session: state.context.session,
        // Starter Custom Code
        productInfoByProductId:
            state.components.productInfoLists.productInfoListById[carouselId]?.productInfoByProductId,
        carouselId,
    };
};

const mapDispatchToProps = {
    loadCarouselProducts,
    sendImpressionTracking,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme> &
    HasShellContext;

export interface ProductCarouselStyles {
    errorMessageText?: TypographyPresentationProps;
    titleText?: TypographyPresentationProps;
    skipCarouselButton?: SkipNavStyles;
    mainContainer?: GridContainerProps;
    prevArrowGridItem?: GridItemProps;
    prevArrowButton?: ButtonPresentationProps;
    nextArrowGridItem?: GridItemProps;
    nextArrowButton?: ButtonPresentationProps;
    carouselGridItem?: GridItemProps;
    carouselWrapper?: InjectableCss;
    carouselContainer?: InjectableCss;
    carouselSlidesContainer?: InjectableCss;
    carouselSlide?: InjectableCss;
    carouselSlideInner?: InjectableCss;
    carouselProductStyles?: ProductCarouselProductStyles;
    // Starter Custom Code
    block?: BlockProps;
    prevArrowWrapper?: InjectableCss;
    nextArrowWrapper?: InjectableCss;
    dotsWrapper?: InjectableCss;
    dotButton?: ButtonPresentationProps;
    dotButtonSelected?: ButtonPresentationProps;
}

export const productCarouselStyles: ProductCarouselStyles = {
    titleText: carouselProps.titleText,
    prevArrowWrapper: carouselProps.prevArrowWrapper,
    prevArrowButton: carouselProps.prevArrowButton,
    nextArrowWrapper: carouselProps.nextArrowWrapper,
    nextArrowButton: carouselProps.nextArrowButton,
    carouselWrapper: carouselProps.carouselWrapper,
    carouselContainer: carouselProps.carouselContainer,
    // Store Custom Code
    carouselSlidesContainer: {
        css: css`
            ${carouselProps.carouselSlidesContainer?.css}
            ${breakpointValues([0, 0, 0, 0, 0], ["margin"])}
        `,
    },

    carouselSlide: carouselProps.carouselSlide,
    carouselSlideInner: productCardProps.card,
    errorMessageText: {
        color: "danger",
    },
    dotsWrapper: carouselProps.dotsWrapper,
    dotButton: carouselProps.dotButton,
    dotButtonSelected: carouselProps.dotButtonSelected,
};

const styles = productCarouselStyles;
/* Store Custom Code - Product Recommendation Ids are updated twice(one of them from an external call in perius that we don't control) so
    to avoid unneccesary api calls and state updates we're checking to make sure the widgets have changed */
const checkIfPreviousWidgetsHaveChanged = (
    previousWidgets: ProductRecommendationWidgetModel[] | undefined,
    productRecommendationWidgets: ProductRecommendationWidgetModel[] | undefined,
) => {
    if (previousWidgets?.length !== productRecommendationWidgets?.length) {
        return true;
    }

    if (!previousWidgets && productRecommendationWidgets) {
        return true;
    }

    if (!previousWidgets || !productRecommendationWidgets) {
        return false;
    }

    return previousWidgets.some(({ recs: previousWidgetRecs }, index) => {
        const currentWidgetRecs = productRecommendationWidgets[index]?.recs;
        if (!currentWidgetRecs) {
            return true;
        }

        return !currentWidgetRecs.every((rec, recIndex) => rec.refCode === previousWidgetRecs[recIndex]?.refCode);
    });
};

const ProductCarousel = ({
    id,
    theme,
    fields,
    errorMessage,
    loadCarouselProducts,
    pageType,
    shellContext,
    productRecommendationWidgets,
    sendImpressionTracking,
    session,
    // Starter Custom Code
    carouselId,
    productInfoByProductId,
}: Props) => {
    /* Store Custom Code - Start */
    const baseProducts = useAppSelector(state => {
        const mapId = state.components.productInfoLists.dataMapping[carouselId];
        const productInfoByProductId =
            state.components.productInfoLists.productInfoListById[mapId || carouselId]?.productInfoByProductId;
        return productInfoByProductId
            ? Object.keys(productInfoByProductId).map(o => state.data.products.byId[o])
            : undefined;
    }, shallowEqual);
    const filteredProducts = useMemo(() => {
        return baseProducts?.filter(o => o.isVariantParent === false)?.slice(0, fields.numberOfProductsToDisplay) ?? [];
    }, [baseProducts, fields.numberOfProductsToDisplay]);
    const products = useMemo(() => {
        if (fields.hideVariantParents) {
            return filteredProducts;
        }
        return baseProducts;
    }, [baseProducts, fields.hideVariantParents]);
    /* Store Custom Code - End */
    const afterCarousel = createRef<HTMLSpanElement>();
    const isProductDetailsPage = pageType === "ProductDetailsPage";
    const isProductListPage = pageType === "ProductListPage";
    const isBrandDetailsPage = pageType === "BrandDetailsPage";
    const brand = useContext(BrandStateContext).value;
    const category = useContext(CategoryContext);
    const productContext = useContext(ProductContext);
    const wrapperRef = createRef<HTMLDivElement>();
    const [clientWidth, setClientWidth] = useState(0);

    /* Starter Custom Code - Start */
    const title =
        fields.title ||
        translate(carouselTypeOptions.find(o => o.value === fields.carouselType)?.displayName || "Product Carousel");

    const [canTrackViewItemList, setCanTrackViewItemList] = React.useState(false);
    const productInfos = getMatchingDataFromDictionary(products, productInfoByProductId);

    const trackViewItemList = ga.use.trackViewItemList(
        { items: filteredProducts, item_list_name: title, item_list_id: fields.carouselType },
        { productInfos },
    );
    const { enableImageHover, transitionDuration, transitionTimingFunction } = fields;
    ga.use.productInfosCallback(
        productInfos,
        () => {
            setCanTrackViewItemList(false);
            trackViewItemList();
        },
        canTrackViewItemList,
    );
    /* Starter Custom Code - End */

    const numberOfProductsToDisplay = fields.hideVariantParents
        ? fields.numberOfProductsToDisplay * 3
        : fields.numberOfProductsToDisplay; // Store Custom Code

    const previousWidgets = usePrevious(productRecommendationWidgets);

    const previousWidgetsHaveChanged = checkIfPreviousWidgetsHaveChanged(previousWidgets, productRecommendationWidgets);

    useEffect(() => {
        /* Store Custom Code - Start */
        if (fields.carouselType === "recommendedProducts" && !previousWidgetsHaveChanged) {
            return;
        }
        /* Store Custom Code - End */
        loadCarouselProducts({
            isShellEdit: shellContext.isInShell && shellContext.isEditing,
            carouselId, // Starter Custom Code
            carouselType: fields.carouselType,
            relatedProductType: fields.relatedProductType,
            seedWithManuallyAssigned: fields.seedWithManuallyAssigned,
            displayProductsFrom: fields.displayProductsFrom,
            /* Store Custom Code - Start */
            selectedCategoryIds:
                fields.carouselType === "allProducts" ? fields.selectedCategory : fields.selectedCategoryIds,
            /* Store Custom Code - End */
            numberOfProductsToDisplay,
            widgetPosition: fields.widgetPosition,
            isProductDetailsPage,
            productId: productContext?.product?.id,
            isProductListPage,
            category,
            isBrandDetailsPage,
            brand,
        });
        setCanTrackViewItemList(true); // Starter Custom Code
    }, [
        fields.carouselType,
        fields.relatedProductType,
        fields.seedWithManuallyAssigned,
        fields.displayProductsFrom,
        fields.selectedCategoryIds,
        fields.numberOfProductsToDisplay,
        fields.widgetPosition,
        productContext?.product?.id,
        category?.id,
        brand?.id,
        productRecommendationWidgets,
        session?.pickUpWarehouse?.id,
    ]);
    const [emblaRef, embla] = useEmblaCarousel();

    const getSlidesToScroll = () => {
        const maxNumberOfColumns = fields.maxNumberOfColumns || 4;
        let localClientWidth = 0;
        if (wrapperRef.current?.clientWidth && (!clientWidth || clientWidth !== wrapperRef.current?.clientWidth)) {
            localClientWidth = wrapperRef.current.getBoundingClientRect().width;
            setClientWidth(localClientWidth);
        }
        if (typeof window === "undefined") {
            return maxNumberOfColumns;
        }
        const clientWidthToUse = localClientWidth || clientWidth;

        let localSlidesToScroll: number;
        const { innerWidth } = window;
        if (clientWidthToUse && innerWidth > theme.breakpoints.values[1]) {
            const minSlideWidth = 300;
            const maxNumberOfSlides = Math.floor(clientWidthToUse / minSlideWidth);
            if (maxNumberOfSlides < 20) {
                return maxNumberOfSlides;
            }
        }
        if (innerWidth < theme.breakpoints.values[1]) {
            localSlidesToScroll = 1;
        } else if (innerWidth < theme.breakpoints.values[2]) {
            localSlidesToScroll = 2;
        } else if (innerWidth < theme.breakpoints.values[3]) {
            localSlidesToScroll = 3;
        } else {
            localSlidesToScroll = 4;
        }

        return Math.min(localSlidesToScroll, maxNumberOfColumns);
    };
    const [selectedIndex, setSelectedIndex] = useState(0); // Starter Custom Code
    const [windowResizeTime, setWindowResizeTime] = useState(0);
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);
    const setCanScroll = () => {
        if (shellContext.isInShell) {
            return;
        }
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };
    const [slidesToScroll, setSlidesToScroll] = useState(0);

    useEffect(() => {
        const newSlidesToScroll = getSlidesToScroll();
        setSlidesToScroll(newSlidesToScroll);
    }, [fields.maxNumberOfColumns, windowResizeTime, wrapperRef.current?.clientWidth]);

    useEffect(() => {
        if (!embla) {
            return;
        }

        embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);

        /* Starter Custom Code - Start */
        embla.on("select", () => {
            setSelectedIndex(embla.selectedScrollSnap());
        });
        /* Starter Custom Code - End */

        const onWindowResize = () => {
            setWindowResizeTime(Date.now());
        };

        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, [embla]);

    useEffect(() => {
        if (!embla || !products || products.length === 0) {
            return;
        }

        embla.reInit({
            align: "start",
            slidesToScroll,
            watchDrag: isTouchDevice(),
            loop: products.length > slidesToScroll,
        });
        setCanScroll();
    }, [embla, slidesToScroll, productInfoByProductId]); // Starter Custom Code
    useEffect(() => {
        if (
            fields.carouselType !== "recommendedProducts" ||
            !productRecommendationWidgets ||
            fields.widgetPosition > productRecommendationWidgets.length ||
            !products
        ) {
            return;
        }

        const productRecommendationWidget = productRecommendationWidgets[fields.widgetPosition - 1];
        const recommendationIds: number[] = [];
        products?.forEach(o => {
            // Store Custom Code
            const id = productRecommendationWidget.recs.find(r => r.refCode === o.productNumber)?.id;
            if (id) {
                recommendationIds.push(id);
            }
        });

        if (recommendationIds.length) {
            sendImpressionTracking({ recommendationIds });
        }
    }, [fields.carouselType, productRecommendationWidgets, products?.length]);

    const getProductRecommendationId = (product: ProductModel) => {
        if (!productRecommendationWidgets || fields.widgetPosition > productRecommendationWidgets.length) {
            return;
        }

        const productRecommendationWidget = productRecommendationWidgets[fields.widgetPosition - 1];
        // Store Custom Code
        return productRecommendationWidget.recs.find(r => r.refCode === product.productNumber)?.id;
    };

    if (errorMessage && shellContext.isInShell) {
        return (
            <Typography {...styles.errorMessageText} as="p">
                {`Failed to load carousel products. Error: '${errorMessage}'. Please check widget settings.`}
            </Typography>
        );
    }

    if (!products || products.length === 0) {
        return null;
    }

    // Starter Moved - title - up
    const showBrandBlocks = fields.showBrandName && products.some(o => !!o.brand);

    /* Starter Custom Code - Start */
    const { blockFullWidth, blockVariant, blockVariantSide, blockMargin } = fields;
    const variant = fields.variant || ProductCarouselVariant.None;

    const titleAlignmentCss = css`
        ${cssProp("text-align", fields.titleAlignment)}
    `;

    const titleCss = css`
        ${titleAlignmentCss}
        ${styles.titleText?.css}
    `;

    const dotCount = slidesToScroll > 0 ? Math.ceil(products.length / slidesToScroll) : 0;
    const getDots = () => {
        const dots = [];

        for (let i = 0; i < dotCount; i++) {
            dots.push(
                <Button
                    key={i} // eslint-disable-line react/no-array-index-key
                    {...(i === selectedIndex ? styles.dotButtonSelected : styles.dotButton)}
                    aria-current={i === selectedIndex}
                    onClick={() => embla && embla.scrollTo(i)}
                    data-test-selector={`productCarousel_dot_${i}`} /* Store Custom Code */
                >
                    <VisuallyHidden>{translate("Go to slide {0} of {1}", `${i + 1}`, `${dotCount}`)}</VisuallyHidden>
                </Button>,
            );
        }

        return (
            <StyledWrapper
                {...styles.dotsWrapper}
                data-test-selector="productCarousel_dotsWrapper" /* Store Custom Code */
            >
                {dots}
            </StyledWrapper>
        );
    };
    /* Starter Custom Code - End */

    return (
        /* Starter Custom Code - Added "Block" */
        <StyledWrapper
            css={css`
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            `}
        >
            {/* Starter Custom Code - Start */}
            {title ? (
                variant === ProductCarouselVariant.ProductDetails ? (
                    <AnchorHeading
                        fields={{
                            title,
                            anchor: title,
                        }}
                        extendedStyles={{
                            anchorHeading: {
                                title: {
                                    css: titleAlignmentCss,
                                },
                            },
                        }}
                    />
                ) : (
                    <Typography {...styles.titleText} css={titleCss}>
                        {title}
                    </Typography>
                )
            ) : null}
            {/* Starter Custom Code - End */}
            <SkipNav
                text={translate("Skip Carousel")}
                extendedStyles={styles.skipCarouselButton}
                destination={afterCarousel}
            />
            <StyledWrapper // Starter Custom Code
                {...styles.carouselWrapper} // Starter Custom Code
                data-test-selector={`productCarousel_${fields.carouselType}${
                    fields.relatedProductType ? `_${fields.relatedProductType}` : ""
                }`} /* Store Custom Code */
                ref={wrapperRef}
            >
                {/* Starter Custom Code - Start */}
                {products.length > slidesToScroll && (
                    <StyledWrapper {...styles.prevArrowWrapper}>
                        <Button
                            {...styles.prevArrowButton}
                            onClick={() => embla && embla.scrollPrev()}
                            disabled={!canScrollPrev}
                            data-test-selector="productCarousel_prevButton" /* Store Custom Code */
                        >
                            <VisuallyHidden>{translate("Previous slide")}</VisuallyHidden>
                        </Button>
                    </StyledWrapper>
                )}
                {/* Starter Custom Code - End */}
                {/* Starter Removed - carouselGridItem */}
                {/* Starter Removed - carouselWrapper */}
                <StyledWrapper {...styles.carouselContainer} ref={emblaRef}>
                    <StyledWrapper
                        {...styles.carouselSlidesContainer}
                        data-test-selector="productCarousel_slides" /* Store Custom Code */
                    >
                        {products.map(product => (
                            <StyledWrapper
                                {...styles.carouselSlide}
                                key={product.id}
                                style={{
                                    width: `${100 / slidesToScroll}%`,
                                    minHeight: "490px",
                                }}
                            >
                                <StyledWrapper
                                    {...styles.carouselSlideInner}
                                    id={`product_${product.id}`}
                                    data-test-key={product.id}
                                    data-test-selector="productCarousel_slide" /* Store Custom Code */
                                >
                                    <ProductCarouselProduct
                                        carouselId={carouselId} // Starter Custom Code
                                        product={product}
                                        recommendationId={getProductRecommendationId(product)}
                                        showImage={fields.showImage}
                                        showBrand={showBrandBlocks}
                                        showTitle={fields.showTitle}
                                        showPartNumbers={fields.showPartNumbers}
                                        showPrice={fields.showPrice}
                                        showAddToCart={fields.showAddToCart}
                                        showAddToList={fields.showAddToList}
                                        showImageBadges={fields.showImageBadges}
                                        maximumNumberOfImageBadges={fields.maximumNumberOfImageBadges}
                                        showTextBadges={fields.showTextBadges}
                                        maximumNumberOfTextBadges={fields.maximumNumberOfTextBadges}
                                        extendedStyles={styles.carouselProductStyles}
                                        // Starter Custom Code
                                        showAvailability={fields.showAvailability}
                                        showAttributes={fields.showAttributes}
                                        // Store Custom Code
                                        enableImageHover={enableImageHover}
                                        transitionDuration={transitionDuration}
                                        transitionTimingFunction={transitionTimingFunction}
                                    />
                                </StyledWrapper>
                            </StyledWrapper>
                        ))}
                    </StyledWrapper>
                </StyledWrapper>
                {/* Starter Custom Code - Start */}
                {products.length > slidesToScroll ? (
                    <StyledWrapper {...styles.nextArrowWrapper}>
                        <Button
                            {...styles.nextArrowButton}
                            onClick={() => embla && embla.scrollNext()}
                            disabled={!canScrollNext}
                            data-test-selector="productCarousel_nextButton" /* Store Custom Code */
                        >
                            <VisuallyHidden>{translate("Next slide")}</VisuallyHidden>
                        </Button>
                    </StyledWrapper>
                ) : null}
                {/* Starter Custom Code - End */}
            </StyledWrapper>
            {fields.showDots && dotCount > 1 ? getDots() : null /* Starter Custom Code */}
            <span ref={afterCarousel} tabIndex={-1} />
        </StyledWrapper>
    );
};

const carouselTypeOptions = [
    { value: "crossSells", displayName: "Cross Sells" },
    { value: "allProducts", displayName: "All Products" },
    { value: "customersAlsoPurchased", displayName: "Customers Also Purchased" },
    { value: "recentlyViewed", displayName: "Recently Viewed" },
    { value: "relatedProducts", displayName: "Related Products" },
    { value: "topSellers", displayName: "Top Sellers" },
    { value: "recommendedProducts", displayName: "Recommended Products" },
];

/* Starter Custom Code - Start */
const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};
/* Starter Custom Code - End */

const widgetModule: WidgetModule = {
    /* Starter Custom Code - Start */
    component: withProductContext(
        connect(mapStateToProps, mapDispatchToProps)(withIsInShell(withTheme(ProductCarousel))),
    ),
    /* Starter Custom Code - End */
    definition: {
        group: "Common",
        icon: "gallery-thumbnails",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
            },
            /* Starter Custom Code - Start */
            {
                ...titleAlignmentField.definition,
                displayName: "Title Alignment",
                defaultValue: textAlignmentOptions.center.id,
                fieldType: "Contextual",
            },
            {
                name: fields.variant,
                displayName: "Variant",
                editorTemplate: "DropDownField",
                options: [{ displayName: "Product Details", value: ProductCarouselVariant.ProductDetails }],
                defaultValue: ProductCarouselVariant.None,
                fieldType: "Contextual",
            },
            /* Starter Custom Code - End */
            {
                name: fields.carouselType,
                displayName: "Carousel Type",
                editorTemplate: "DropDownField",
                options: carouselTypeOptions,
                defaultValue: "crossSells",
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
                customFilter: (item, _, settings) => {
                    const {
                        settingsCollection: {
                            websiteSettings: { enableDynamicRecommendations },
                            productSettings: { enableProductRecommendations },
                        },
                    } = settings;

                    if (!enableDynamicRecommendations && item.value === "topSellers") {
                        return false;
                    }

                    if (!enableProductRecommendations && item.value === "recommendedProducts") {
                        return false;
                    }

                    return true;
                },
            },
            {
                name: fields.displayProductsFrom,
                displayName: "Display Products From",
                editorTemplate: "DropDownField",
                options: [
                    { value: "allCategories", displayName: "All Categories" },
                    { value: "selectedCategories", displayName: "Selected Categories" },
                    { value: "customerSegments", displayName: "Customer Segments" },
                ],
                defaultValue: "allCategories",
                fieldType: "Contextual",
                isVisible: item =>
                    item.fields[fields.carouselType] === "topSellers" ||
                    item.fields[fields.carouselType] === "allProducts",

                /* Starter Removed - sortOrder */
            },
            {
                name: fields.selectedCategoryIds,
                displayName: "Selected Categories",
                editorTemplate: "CategoriesField",
                defaultValue: [],
                fieldType: "Contextual",
                isVisible: item =>
                    item.fields[fields.carouselType] === "topSellers" &&
                    item.fields[fields.displayProductsFrom] === "selectedCategories",
                /* Starter Removed - sortOrder */
            },
            /* Store Custom Code - Start */
            {
                name: fields.selectedCategory,
                displayName: "Select Category",
                editorTemplate: "CategoriesField",
                defaultValue: [],
                fieldType: "General",
                isVisible: item =>
                    item.fields[fields.carouselType] === "allProducts" &&
                    item.fields[fields.displayProductsFrom] === "selectedCategories",
                sortOrder: 3,
                singleCategorySelection: () => true,
            },
            /* Store Custom Code - End */
            {
                name: fields.relatedProductType,
                displayName: "Related Product Type",
                editorTemplate: "SystemListDropDownField",
                systemListName: "ProductRelationship",
                defaultValue: "",
                fieldType: "Contextual",
                isVisible: item => item.fields[fields.carouselType] === "relatedProducts",
                /* Starter Removed - sortOrder */
            },

            {
                name: fields.numberOfProductsToDisplay,
                displayName: "Number Of Products To Display",
                editorTemplate: "IntegerField",
                min: 1,
                max: 20,
                defaultValue: 10,
                fieldType: "Contextual",
                isVisible: item =>
                    item.fields[fields.carouselType] === "customersAlsoPurchased" ||
                    item.fields[fields.carouselType] === "topSellers",
                /* Starter Removed - sortOrder */
            },
            {
                name: fields.seedWithManuallyAssigned,
                displayName: "Seed With Manually Assigned",
                editorTemplate: "SystemListDropDownField",
                systemListName: "ProductRelationship",
                defaultValue: "",
                fieldType: "Contextual",
                isVisible: (item, _advancedFeaturesEnabled, _theme, pageType) =>
                    pageType === "ProductDetailsPage" && item.fields[fields.carouselType] === "customersAlsoPurchased",
                /* Starter Removed - sortOrder */
            },
            {
                name: fields.maxNumberOfColumns,
                displayName: "Max Number Of Columns",
                editorTemplate: "IntegerField",
                min: 1,
                max: 4,
                defaultValue: 4,
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
            },
            {
                name: fields.widgetPosition,
                displayName: "Widget Position",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 1,
                fieldType: "Contextual",
                isVisible: item => item.fields[fields.carouselType] === "recommendedProducts",
                /* Starter Removed - sortOrder */
            },
            {
                name: fields.showImage,
                displayName: "Image",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                /* Starter Removed - isEnabled */
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
            },
            {
                name: fields.showTitle,
                displayName: "Title",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                /* Starter Removed - isEnabled */
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
            },
            {
                name: fields.showBrandName,
                displayName: "Brand Name",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
            },
            {
                name: fields.showPartNumbers,
                displayName: "Part Numbers",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
            },
            /* Starter Custom Code - Start */
            {
                name: fields.showAvailability,
                displayName: "Show Availability",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
            },
            {
                name: fields.showAttributes,
                displayName: "Show Attributes",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
            },
            /* Starter Custom Code - End */
            {
                name: fields.showPrice,
                displayName: "Price",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
            },
            {
                name: fields.showAddToCart,
                displayName: "Add to Cart",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
            },
            {
                name: fields.showAddToList,
                displayName: "Add to List",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
            },
            {
                name: fields.showImageBadges,
                displayName: "Image Badges",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
            },
            {
                name: fields.hideVariantParents,
                displayName: "Hide Variant Parents",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
            },
            {
                name: fields.maximumNumberOfImageBadges,
                editorTemplate: "DropDownField",
                isVisible: widget => widget.fields.showImageBadges,
                defaultValue: "4",
                options: [
                    { displayName: "1", value: "1" },
                    { displayName: "2", value: "2" },
                    { displayName: "3", value: "3" },
                    { displayName: "4", value: "4" },
                    { displayName: "5", value: "5" },
                    { displayName: "6", value: "6" },
                    { displayName: "7", value: "7" },
                    { displayName: "8", value: "8" },
                ],
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
            },
            {
                name: fields.showTextBadges,
                displayName: "Text Badges",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
            },
            {
                name: fields.maximumNumberOfTextBadges,
                editorTemplate: "DropDownField",
                isVisible: widget => widget.fields.showTextBadges,
                defaultValue: "4",
                options: [
                    { displayName: "1", value: "1" },
                    { displayName: "2", value: "2" },
                    { displayName: "3", value: "3" },
                    { displayName: "4", value: "4" },
                    { displayName: "5", value: "5" },
                    { displayName: "6", value: "6" },
                    { displayName: "7", value: "7" },
                    { displayName: "8", value: "8" },
                ],
                fieldType: "Contextual",
                /* Starter Removed - sortOrder */
            },
            /* Starter Custom Code - Start */
            {
                name: fields.showDots,
                displayName: "Show Dots",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
            },
            {
                ...blockVariantField,
                name: fields.blockVariant,
                fieldType: "Contextual",
                tab: advancedTab,
            },
            {
                ...blockVariantSideField,
                name: fields.blockVariantSide,
                fieldType: "Contextual",
                tab: advancedTab,
            },
            {
                ...blockFullWidthField,
                name: fields.blockFullWidth,
                fieldType: "Contextual",
                tab: advancedTab,
            },
            {
                ...blockMarginField,
                name: fields.blockMargin,
                fieldType: "Contextual",
                tab: advancedTab,
            },
            /* Starter Custom Code - End */
            ...imageHoverOptions,
        ],
    },
};

export default widgetModule;
